import React from "react";

export const CardSumary = ({
  supervisor,
  demonstrators,
}: {
  supervisor: number;
  demonstrators: number;
}) => {
  return (
    <div className="absolute bg-[rgba(255,255,255,.6)] top-[50px] left-[15px] max-w-sm rounded-[15px] overflow-hidden shadow-lg p-2 w-64 card-s-top">
      <div className="p-2">
        <div className="flex">
          <p className="text-[16px] w-1/6">{demonstrators}</p>
          <p className="font-bold text-[16px] px-2">Demostradores Activos</p>
        </div>
        <div className="flex">
          <p className="text-[16px] w-1/6">{supervisor}</p>
          <p className="font-bold text-[16px] px-2">Supervisores Activos</p>
        </div>
      </div>
    </div>
  );
};
